"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function DollarFast16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1C12.5523 1 13 1.44772 13 2L13.0007 3.03898C14.0488 3.14921 15.0829 3.48864 15.8277 3.99815L15.0239 5.56932C14.1244 5.03327 12.9952 4.70055 12.0957 4.70055C11.2344 4.70055 10.6029 4.97782 10.6029 5.68022C10.6029 7.49168 16.0191 6.51201 16 10.0795C16 11.7912 14.66 12.7024 13.0012 12.9378L13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14L11.0005 12.916C9.86501 12.7425 8.76795 12.3039 8 11.6322L8.78468 10.1165C9.66506 10.8743 11.0813 11.3364 12.1914 11.3364C13.1292 11.3364 13.8564 11.0222 13.8564 10.2828C13.8564 8.26802 8.4976 9.39556 8.51674 5.84658C8.51674 4.2966 9.60127 3.43748 10.9999 3.13081L11 2C11 1.44772 11.4477 1 12 1ZM7 11V13H4V11H7ZM7 7V9H2V7H7ZM7 3V5H0V3H7Z", fill: "#000000" }));
}
function DollarFast16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(DollarFast16Svg, Object.assign({}, svgProps)));
}
exports.default = DollarFast16;
//# sourceMappingURL=DollarFast16.js.map